<template>
  <label class="generic-touchpoint" :class="{ 'generic-touchpoint--wide': isFullWidth }" :for="fullInputId">
    <input
      type="radio"
      :id="fullInputId"
      :value="inputValue"
      class="generic-touchpoint__input"
      :name="collectionName"
      @change="updateValue($event)"
      v-validate="validationRules"
      :data-vv-scope="validationScope"
      :checked="isSelected"/>

    <div class="generic-touchpoint__container" :class="{ 'generic-touchpoint__container--radio': isRadioStyle }">
      <slot name="touchpoint">
        {{inputValue}}
      </slot>
    </div>
  </label>
</template>
<script lang="ts">
import VeeValidate, { FieldError, Validator } from 'vee-validate';
import {
  Vue, Component, Prop, Inject
} from 'vue-property-decorator';

@Component
export default class GenericTouchPointComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: null })
  public inputId!: string;

  @Prop({ default: null })
  public inputValue: any;

  @Prop({ default: null })
  public collectionName!: string;

  @Prop({ default: 'required' })
  public validationRules!: string;

  @Prop({ default: false })
  public isFullWidth!: boolean;

  @Prop({ default: false })
  public isSelected!: boolean;

  @Prop({ default: false })
  public isRadioStyle!: boolean;

  @Prop({ default: null })
  public validationScope!: string;

  public get fullInputId(): string {
    return `${this.collectionName}-${this.inputId}`;
  }

  public updateValue(e: any) {
    this.$emit(this.collectionName, e.target.value);
  }

  public created() {
    this.$validator.validateAll(this.validationScope);
  }
}
</script>
